let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("902Qs")).then(() => parcelRequire('50IoF'));